import { connect, getStoreInfo, iAmReady } from '@tiendanube/nexo';
import { useEffect, useState } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';

import nexo from './nexoClient';
import NexoSyncRoute from './NexoSyncRoute';
import { BillingPage, MainPage, OrdersPage, UnauthorizedPage } from './pages';
import { DarkModeProvider, BaseLayout } from './components';

import { ToastProvider } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';

function App() {
  const [isConnect, setIsConnect] = useState(false);

  const { i18n } = useTranslation();

  useEffect(() => {
    connect(nexo).then(() => {
      setIsConnect(true);
      iAmReady(nexo);

      getStoreInfo(nexo).then((store: { language: string }) => {
        i18n.changeLanguage(store.language);
      });
    });
  }, [i18n]);

  if (!isConnect) return <div>connecting..</div>;

  return (
    <DarkModeProvider>
      <HashRouter>
        <ToastProvider>
          <BaseLayout getStoreInfo={getStoreInfo} nexo={nexo}>
            <NexoSyncRoute>
              <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/customer/:id/orders" element={<OrdersPage />} />
                <Route path="/billing" element={<BillingPage />} />
                <Route path="/unauthorized" element={<UnauthorizedPage />} />
              </Routes>
            </NexoSyncRoute>
          </BaseLayout>
        </ToastProvider>
      </HashRouter>
    </DarkModeProvider>
  );
}

export default App;
